export const ALLOWED_MARK_COMPLETED_STATUSES = [
  "ASSIGNED",
  "POSING",
  "NON_COMPLIED",
  "RE_OPENED",
  "REOPENED",
];

export const RESTRICTED_MARK_COMPLETED_STATUSES = ALLOWED_MARK_COMPLETED_STATUSES;

const normalizeStatus = (status?: string | null) => {
  if (!status || typeof status !== "string") {
    return "";
  }
  return status.trim().toUpperCase().replace(/[\s-]+/g, "_");
};

export const canShowMarkCompleted = (status?: string | null) => {
  const normalizedStatus = normalizeStatus(status);

  if (!normalizedStatus) {
    return false;
  }

  return ALLOWED_MARK_COMPLETED_STATUSES.includes(normalizedStatus);
};
